import Logo from "@components/logo";
import { MainMenu, MobileMenu } from "@components/menu";
import { useSticky } from "@hooks";
import BurgerButton from "@ui/burger-button";
import OffCanvas, { OffCanvasBody, OffCanvasHeader } from "@ui/off-canvas";
import { Container } from "@ui/wrapper";
import PropTypes from "prop-types";
import React, { Fragment, useState } from "react";
import {
    HeaderBottom,
    HeaderCol,
    HeaderElement,
    HeaderMain,
    HeaderNavigation,
    HeaderWrap,
} from "./style";

const Header = ({ data, transparent }) => {
    const { sticky, headerRef, fixedRef } = useSticky();
    const [offCanvasOpen, setOffcanvasOpen] = useState(false);

    const offCanvasHandler = () => {
        setOffcanvasOpen((prevState) => !prevState);
    };

    return (
        <Fragment>
            <HeaderWrap
                ref={headerRef}
                isSticky={sticky}
                $transparent={transparent}
            >
                <HeaderBottom ref={fixedRef} isSticky={sticky}>
                    <Container>
                        <HeaderMain>
                            <HeaderCol left>
                                <Logo
                                    py="14px"
                                    variant={
                                        transparent && !sticky
                                            ? "white"
                                            : "dark"
                                    }
                                />
                            </HeaderCol>

                            <HeaderCol center>
                                {data?.menu && (
                                    <HeaderNavigation>
                                        <MainMenu
                                            color={
                                                transparent && !sticky
                                                    ? "white"
                                                    : "dark"
                                            }
                                            alignment="right"
                                            menuData={data.menu}
                                            space={2}
                                            vSpace={2}
                                            bottomLine={false}
                                        />
                                    </HeaderNavigation>
                                )}
                            </HeaderCol>

                            <HeaderCol right>
                                <HeaderElement
                                    pl="25px"
                                    display={["flex", null, null, null, "none"]}
                                >
                                    <BurgerButton
                                        className="burger-btn"
                                        onClick={offCanvasHandler}
                                    />
                                </HeaderElement>
                            </HeaderCol>
                        </HeaderMain>
                    </Container>
                </HeaderBottom>
            </HeaderWrap>

            <OffCanvas
                scrollable={true}
                isOpen={offCanvasOpen}
                onClick={offCanvasHandler}
            >
                <OffCanvasHeader onClick={offCanvasHandler}>
                    <Logo darkLogo align={{ default: "flex-start" }} />
                </OffCanvasHeader>
                <OffCanvasBody>
                    {data?.menu && <MobileMenu menuData={data.menu} />}
                </OffCanvasBody>
            </OffCanvas>
        </Fragment>
    );
};

Header.propTypes = {
    data: PropTypes.shape({
        menu: PropTypes.arrayOf(PropTypes.shape({})),
        slogan: PropTypes.string,
        contact: PropTypes.shape({
            phone: PropTypes.string,
            address: PropTypes.string,
        }),
    }),
    transparent: PropTypes.bool,
};

Header.defaultProps = {
    transparent: false,
};

export default Header;
